export function getSession (key) {
  var data = sessionStorage[key]
  if (!data || data === 'null') {
    return null
  }
  return JSON.parse(data).value
}

export function setSession (key, value) {
  var data = {
    value: value
  }
  sessionStorage[key] = JSON.stringify(data)
}



// WEBPACK FOOTER //
// ./src/utils/session.js